"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cadelbosco-di-sopra": {
    "1f758cdc": [{
      "hkey": "797be6ec",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "cadelbosco-di-sopra": [{
      "hkey": "797be6ec",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0d24805b": [{
      "hkey": "ca3ca4b3",
      "slug": "argine",
      "name": "Argine",
      "primary": true,
      "skipSearch": false
    }],
    "villa-argine": [{
      "hkey": "ca3ca4b3",
      "slug": "argine",
      "name": "Argine",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;